export default {"src":"/_next/static/media/time.aad4a6a7.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};